import React from 'react'
import Modal from 'react-bootstrap/lib/Modal'
import ColorPicker from '../color_picker'
import { genColor, labelToMap } from '../../util/tag_utils'
import TagGoal from '../tag_goal'
import { ExpiredTrialAlertWindow } from '../alert_window'
import { makeToast } from '../../util/toast_util'

class TagModal extends React.Component {
    constructor(props) {
        super(props)

        this.handleClose = this.handleClose.bind(this)
        this.handleSave = this.handleSave.bind(this)
        this.handleDelete = this.handleDelete.bind(this)
        this.handleChange = this.handleChange.bind(this)
        this.clearModal = this.clearModal.bind(this)
        this.selectOnce = this.selectOnce.bind(this)
        this.isAuthorized = this.isAuthorized.bind(this)
        this.getTagGoal = this.getTagGoal.bind(this)

        const tagGoal = this.getTagGoal(props.selectedTagId)

        this.state = {
            id: null,
            userId: null,
            teamId: null,
            name: null,
            color: null,
            editMode: false,
            dirty: false,
            activeGoal: !!tagGoal,
            tagGoal: null,
            showAlertModal: false,
        }
    }

    clearModal(nextFn) {
        this.setState({
            id: null,
            userId: null,
            teamId: null,
            name: null,
            color: null,
            editMode: false,
            dirty: false,
            tagGoal: null,
        }, nextFn)
    }

    componentWillReceiveProps(nextProps) {
        if (!nextProps.show && this.props.show) {
            this.clearModal()
            return
        }

        if (!nextProps.selectedTagId && !!this.props.selectedTagId) {
            this.clearModal()
            return
        }

        if ( (nextProps.selectedTagId && this.props.selectedTagId !== nextProps.selectedTagId)
          || (nextProps.show && !this.props.show)
          || (this.state.id !== nextProps.selectedTagId)
        ) {
            this.loadTag(nextProps)
        }
    }

    loadTag(props) {
        const { tags, selectedTagId: id, goals } = props
        // load the tag
        const tag = tags.items[id]
        if (tag) {
            const tagGoal = this.getTagGoal(tag ? tag.id : undefined, goals)
            this.setState({ ...tag, editMode: true, tagGoal, activeGoal: !!tagGoal })
        }
    }

    getTagGoal(tagId, goals) {
        if (!goals) {
            return
        }
        // load the first goal that matches, if the tag exists
        const goalsArray = goals.sort.reduce((acc, k) => [...acc, goals.items[k]], []) || []
        return !tagId ? undefined :
            goalsArray.find(goal =>
                goal.visibility === 'team' && goal.tags.find(t => t.tagId === tagId)
            )
    }

    setTitle(tag) {
        const prefix = tag ? 'Edit' : 'Create New'
        document.title = `${prefix} Tag | Shoutbase`
    }

    isAuthorized(shortname) {
        // if there's no shortname, it's a personal tag and can therefore be created
        // return !shortname || isTeamAdmin.call(this, shortname)
        return !shortname
    }

    hideAlertModal = () => {
        this.setState({ showAlertModal: false })
    }

    openUpgradeModal = () => {
        this.setState({ showAlertModal: false }, () => {
            this.props.setPaymentModalOpen(true)
        })
    }

    handleSave() {
        const { id, color, name, teamId, tagGoal: goalMeta, activeGoal, editMode } = this.state
        const { createTag, updateTag, profile, dashboardTeamId, trialEnd } = this.props
        const { tagName } = labelToMap(name)
        const activeTeamId = teamId || dashboardTeamId
        const isPersonalTeam = profile.personalTeamId === activeTeamId

        if (!name) return

        const accountIsExpired = trialEnd && new Date(trialEnd) < new Date()
        if (!editMode && accountIsExpired && !isPersonalTeam) {
            this.setState({ showAlertModal: true })
            return
        }

        const tagMeta = {
            userId: profile.id,
            teamId: activeTeamId,
            id: id,
            color: color || genColor(name),
            name: tagName,
        }

        const isNew = id === null
        const deleteGoal = !isNew
            && activeGoal === false
            && !!goalMeta
            && !!goalMeta.id

        if (goalMeta) {
            goalMeta.teamId = tagMeta.teamId
        }

        isNew ?
            createTag(tagMeta, goalMeta) :
            updateTag(tagMeta, goalMeta, deleteGoal)

        this.clearModal(this.handleClose)
    }

    deleteTagAction = () => {
        const { id, name } = this.state
        const tagMeta = {
            id,
            name,
        }

        this.props.deleteTag(tagMeta)
        this.handleClose()
    }

    handleDelete = () => {
        const { name } = this.state
        const msg = `Are you sure you want to delete the "${name}" tag? It will be removed from all existing time entries.`
        const ind = "warning"
        const action = {
            text: "YES",
            onClick: this.deleteTagAction,
        }

        makeToast(msg, ind, action)
    }

    handleClose() {
        this.props.closeTagModal()
    }

    setColor(color) {
        this.setState({ color: color })
    }

    selectOnce(ref) {
        ref.select()
        this.setState({ dirty: true })
    }

    handleChange(e) {
        this.setState({ [e.target.name]: e.target.value })
    }

    canSave = () => {
        const { name } = this.state
        return name && !!name.trim()
    }

    toggleTagGoal = () => {
        const { activeGoal } = this.state
        this.setState({
            activeGoal: !activeGoal,
        })
    }

    onTagGoalUpdate = (goalMeta) => {
        console.log(goalMeta) // eslint-disable-line no-console

        const { tagGoal={} } = this.state
        const { interval, hours } = goalMeta
        const budgetDuration = hours * 60 * 60
        const visibility = "team"

        const updatedGoal = {
            ...tagGoal,
            interval,
            budgetDuration,
            visibility,
        }

        console.log(goalMeta, updatedGoal) // eslint-disable-line no-console

        this.setState({
            tagGoal: updatedGoal,
        })
    }

    render() {
        const { editMode, name, color, dirty, activeGoal, tagGoal={} } = this.state
        const { show, showTagGoal, profile } = this.props
        const title = editMode ? "Edit Tag" : "New Tag"
        const showTrashCan = editMode

        // goal details
        const isNew    = !tagGoal || !tagGoal.id
        const interval = !tagGoal ? "week" : tagGoal.interval || "week"
        const hours    = !tagGoal ? 0 : tagGoal.budgetDuration ? tagGoal.budgetDuration / 60 / 60 : 0
        const isTagGoalOpen = activeGoal === true

        return (
            <div>
                <Modal show={show} onHide={this.handleClose} className="tag-modal-container modal-v2">
                    <ExpiredTrialAlertWindow
                        isOpen={this.state.showAlertModal}
                        handleCloseAlert={this.hideAlertModal}
                        team={this.props.team}
                        accountName={""}
                        type="TAG"
                        upgrade={this.openUpgradeModal}
                        personalTeamId={""}
                        userId={profile.id}
                    />
                    <Modal.Header closeButton>
                        <Modal.Title>{title}</Modal.Title>
                    </Modal.Header>

                    <Modal.Body className="tag-modal-body">
                        <div className="tag-modal-content">
                            <div className="form-group">
                                <label>Tag name</label>
                                <input type="text" className="form-control" name="name" ref={ref => ref && !dirty && this.selectOnce(ref)} value={name || ''} onChange={this.handleChange} />
                            </div>
                            <ColorPicker color={color} setColor={this.setColor.bind(this)} />
                            {showTagGoal && <TagGoal onClick={this.toggleTagGoal}
                                on={isTagGoalOpen}
                                onUpdate={this.onTagGoalUpdate}
                                isNew={isNew}
                                interval={interval}
                                hours={hours}
                            />}
                        </div>
                        <div className="tag-modal-error">
                            {/*{ TODO: add validation logic and elements here}*/}
                        </div>
                    </Modal.Body>

                    <Modal.Footer>
                        <div className="row tag-modal-footer">
                            <div className="tag-modal-controls">
                                <div className="tag-modal-trash" onClick={this.handleDelete}>
                                    {showTrashCan && <i className="fa fa-trash-o" aria-hidden="true"></i>}
                                </div>
                                {this.state.id && <span className="tag-id"> ID: {this.state.id}</span>}
                                <div className="tag-btn-group">
                                    <button className="btn btn-default btn-spacer" type="button" onClick={this.handleClose}>Cancel</button>
                                    <button disabled={!this.canSave()}
                                        className="btn btn-primary btn-spacer" type="button"
                                        onClick={this.handleSave}>{editMode ? "Save" : "Create"}</button>
                                </div>
                            </div>
                        </div>
                    </Modal.Footer>

                </Modal>
            </div>
        )
    }
}

export default TagModal



// WEBPACK FOOTER //
// ./src/components/modals/tag_modal.jsx